import { gql } from '@apollo/client';
const FileSystemDocumentFragment = gql `
  fragment FileSystemDocumentFragment on FileSystemDocument {
    id
    name
    categoryId
    folderId: parentId
    draftId
    createdAt
    type
    acl: acls {
      id
      userId
    }

    htmlBody
    htmlConversionStatus

    files {
      id
      companyId
      name
      path
      type: mimeType
      size
      signed(name: "preview") {
        url
      }
    }

    lastSignRequest {
      id
      status
      document: file_system_document {
        id
      }
    }

    lastApprovalRequest {
      id
      status
    }

    category {
      id
    }

    draft {
      id
      result
      composerId: composer_id
      templateId: template_version_template_id
      templateVersion: unstable__templateVersion {
        reference
        templateId
        source: body
        template {
          id
          marketLocale {
            locale
          }
        }
      }
      tree {
        id
        version
        outdated
      }
    }
  }
`;
export const documentQuery = gql `
  query getDocument($id: ID!, $companyId: UUID!) {
    company(id: $companyId) {
      id
      esigningProvider {
        id
        companyId
        esigningProviderId
        expiresAt
      }
      logoPath: logo_path
      logoUploaded: logo_uploaded
    }

    esigningProviders {
      id
      name
    }

    ancestors: fileSystemAncestors(id: $id) {
      id
      name
    }

    document: fileSystemDocument(id: $id) {
      ...FileSystemDocumentFragment
    }

    users: companyUsers(
      where: { company: { id: { _eq: $companyId } } }
      order_by: [{ user: { name: asc, email: asc } }]
    ) {
      id
      role
      user {
        id
        name
        email
      }
    }

    entry: fileSystemEntry(id: $id) {
      id
      name
      acl: acls {
        id
        userId
        actions
        user {
          id
          name
          email
        }
      }
    }
  }

  ${FileSystemDocumentFragment}
`;
